import * as React from 'react';

import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useTranslation } from 'react-i18next';
import Header from "../../Layouts/Shop/Header";
import HeaderBlock from "../Blocks/HeaderBlock";

const SelectFilter = ({ onClose, open, value, setValue }) => {

    const {t} = useTranslation();

    const options = [
        ['0', t('by_novelty')],
        ['1', t('descending_order_of_price')],
        ['2', t('ascending_order_of_price')]
    ];

    const radioGroupRef = React.useRef(null);

    React.useEffect(() => {
        if (!open) {
            setValue(value);
        }
    }, [value, open]);

    const handleEntering = () => {
        if (radioGroupRef.current != null) {
            radioGroupRef.current.focus();
        }
    };

    const handleCancel = () => {
        onClose();
    };

    const handleOk = () => {
        onClose(value);
    };

    const handleChange = (event) => {
        setValue(event.target.value);
        onClose();
    };

    return (
        <Dialog
            sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
            maxWidth="xs"
            TransitionProps={{ onEntering: handleEntering }}
            open={open}
            onClose={handleCancel}
        >
            <DialogContent sx={{padding: "8px"}} dividers>
                <HeaderBlock>{t('filter')}</HeaderBlock>
                <RadioGroup
                    ref={radioGroupRef}
                    aria-label="filter-menu"
                    name="filter-menu"
                    value={value}
                    onChange={handleChange}
                >
                    {options.map((option) => (
                        <FormControlLabel
                            value={option[0]}
                            key={option[0]}
                            control={<Radio />}
                            label={option[1]}
                        />
                    ))}
                </RadioGroup>
            </DialogContent>
            {/*<DialogActions>*/}
            {/*    <Button autoFocus onClick={handleCancel}>*/}
            {/*        Отменить*/}
            {/*    </Button>*/}
            {/*    <Button onClick={handleOk}>Ok</Button>*/}
            {/*</DialogActions>*/}
        </Dialog>
    );
};

SelectFilter.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired,
};

export default SelectFilter;